import { getUserAttendance } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useLocation, useParams } from 'react-router';

const ViewAttendance = () => {
    const { id } = useParams();
    const { state } = useLocation();
    const columns = [
        {
            title: 'Start Time',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: 'End Time',
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render : (_, data) => {
                if (data?.date) {
                    const date = new Date(data?.date);
                    return date.toLocaleDateString('en-CA')
                }
            }
        },
        // {
        //     title: 'Actions',
        //     key: 'actions',
        //     render: (_, data) => (
        //         <Space>
        //             <Button onClick={() => navigate('/customer/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
        //             <Button onClick={() => navigate('/customer/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
        //             <Button onClick={() => openCustomerModal(data?._id)} icon={<DeleteOutlined />} size="small" danger>Delete</Button>
        //         </Space>
        //     ),
        // },
    ];

    const searchData = {
        id
    }

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Attendance of {state?.data}</h1>
            </div>
            <TableComponent
                listData={getUserAttendance}
                roleType="agent"
                columns={columns}
                listName="attendance"
                searchData={searchData}
            />
        </div>
    );
};

export default ViewAttendance;

